import React from "react";
import { Footer } from "../global/footer";

interface Props {}

export const LayoutAboutUs: React.FC<Props> = props => {
  return (
    <div className="layout--about-us">
      {props.children}
      <Footer />
    </div>
  );
};
